import useValue from "../../../hooks/useValue";
import { CustomNotification } from "../../../util/CustomNotification";
import * as authService from "../../../services/authService";
import { CustomerSideNextScreenConstants } from "../../../constants/generalConstants";

interface RequestPasswordResetProps {
  handleNextScreen: (value: CustomerSideNextScreenConstants | null) => void;
}

export const useRequestPasswordReset = (props: RequestPasswordResetProps) => {
  /* CONSTANTS */

  /* STATE */

  /* CUSTOM HOOK */
  const { value: saving, handleEnableValue: handleEnableSaving, handleDisableValue: handleDisableSaving } = useValue(false);

  /* HANDLERS */

  const handleBack = () => props.handleNextScreen(null);

  const handleOk = async (data: { username: string }) => {
    try {
      handleEnableSaving();
      const response = await authService.requestResetPasswordAPI(data.username);
      CustomNotification.showSuccessMessage(response.message);
    } catch (error) {
      CustomNotification.showErrorMessage(error);
    } finally {
      handleDisableSaving();
    }
  };

  return { saving, handleBack, handleOk };
};
